import { render, staticRenderFns } from "./LoungeZoneComponent.vue?vue&type=template&id=3b4f458a&"
import script from "./LoungeZoneComponent.vue?vue&type=script&lang=js&"
export * from "./LoungeZoneComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoungeZoneComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports